import React, {useEffect, useState} from 'react';
import moment from 'moment';

import ButtonComponent from '../../common/genericComponents/redesign/buttonComponent/buttonComponent';
import CommunicationIcons from '../../../assets/svgComponents/communicationIcons';
import ShimmerWithEmptyImageComponent from '../../common/genericComponents/redesign/shimmerWithEmptyImageComponent/shimmerWithEmptyImageComponent';

import chatHandoffService from '../../../services/restServices/chatHandoffService';
import expertHomeService from '../../../services/expertHomeService';
import utilsService from '../../../services/utilsService';

import VIDABOO_CONSTANTS from '../../../config/consts';

import userDefaultImage from '../../../assets/svg/user-default-icon.svg';

import './chatRoomTaskOwnerComponent.css';

const ChatRoomTaskOwnerComponent = ({
  isDisabled = false,
  isMentorSide = true,
  chatMessageDto = {},
  chatRowOptionsElement = null,
  senderObjectId = null,
  senderObjectType = null,
  widgetDto = null,
  doWhenActionClick = null,
  onFooterOptionSelected = () => {},
}) => {
  const [selectedActionMentorId, setSelectedActionMentorId] = useState(null);
  const [msgActionMentorDto, setMsgActionMentorDto] = useState(null);
  const [msgActiveMentorProfileImageUrl, setMsgActiveMentorProfileImageUrl] =
    useState(null);
  const [chatHandoffFlow, setChatHandoffFlow] = useState(null);
  const [chatMsgTime, setChatMsgTime] = useState(null);

  useEffect(() => {
    getHandoffFlow();
  }, []);

  useEffect(() => {
    const msgSendTime = chatMessageDto?.sendTime;
    const chatMsgTime = moment(msgSendTime || undefined).format('D MMMM HH:mm');
    setChatMsgTime(chatMsgTime);
  }, [chatMessageDto?.sendTime]);

  useEffect(() => {
    let msgActionMentorDto = null,
      msgActiveMentorProfileImageUrl = null;

    if (selectedActionMentorId) {
      const extendedMentorDto =
        expertHomeService.getWidgetDtoExMentorDtoUsingMentorId(
          [widgetDto],
          selectedActionMentorId,
        )?.extendedMentorDto;

      msgActionMentorDto = extendedMentorDto?.mentorDto;

      if (extendedMentorDto?.photoDto) {
        const manipulationString = 'c_fit,h_50,w_50';
        msgActiveMentorProfileImageUrl = utilsService.getPhotoManipulatedUrl(
          extendedMentorDto.photoDto,
          manipulationString,
        );
      }
    }

    setMsgActionMentorDto(msgActionMentorDto);
    setMsgActiveMentorProfileImageUrl(msgActiveMentorProfileImageUrl);
  }, [selectedActionMentorId]);

  const getHandoffFlow = async () => {
    const chatHandoffFlowId = chatMessageDto.parsedMetaData?.chatHandoffFlowId;
    const chatHandoffResponse =
      await chatHandoffService.getChatHandoffByChatHandoffFlowId(
        senderObjectType,
        senderObjectId,
        chatHandoffFlowId,
      );
    if (chatHandoffResponse.success && chatHandoffResponse.chatHandoffFlow) {
      setChatHandoffFlow(chatHandoffResponse.chatHandoffFlow);
      setSelectedActionMentorId(
        chatHandoffResponse.chatHandoffFlow.selectedActionMentorId,
      );
    } else {
      setChatHandoffFlow(null);
      setSelectedActionMentorId(null);
    }
  };

  const handleVideoChatBtnClick = () => {
    if (selectedActionMentorId) {
      if (utilsService.getIsPersonalPage()) {
        onFooterOptionSelected(VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WEBCALL);
      } else {
        const actionClickData = {
          etClickType: 'start-call',
          etAgentId: selectedActionMentorId,
        };
        if (doWhenActionClick) {
          doWhenActionClick(actionClickData);
        }
      }
    }
  };

  return msgActionMentorDto ? (
    <div className="et-crtoc-content-msg-time-wrap">
      <div
        className={`et-chat-room-task-owner-container ${!isMentorSide ? 'et-chat-room-task-owner-container-client' : ''}`}>
        <img
          className="et-crtoc-mentor-photo"
          src={msgActiveMentorProfileImageUrl || userDefaultImage}
          alt=""
        />
        <div className="et-crtoc-mentor-name-info-txt-wrap">
          <div className="et-crtoc-mentor-name">
            {msgActionMentorDto.displayName}
          </div>
          <div className="et-crtoc-mentor-info-txt">
            {chatHandoffFlow.selectedAction ===
            VIDABOO_CONSTANTS.HANDOFF_ACTIONS.VIDEO_CALL
              ? 'Is ready to take the call, click below to start video call'
              : 'Joined the conversation'}
          </div>
          {chatHandoffFlow.selectedAction ===
            VIDABOO_CONSTANTS.HANDOFF_ACTIONS.VIDEO_CALL && (
            <div className="et-crtoc-selected-hand-off-btn">
              <ButtonComponent
                isDisabled={isDisabled}
                text="Start video chat"
                image={
                  <CommunicationIcons.VideoIcon
                    fillColor={
                      isMentorSide
                        ? '#ffffff'
                        : 'var(--et-mentor-cta-primary-btn-text-color)'
                    }
                    size={30}
                  />
                }
                onClick={handleVideoChatBtnClick}
              />
            </div>
          )}
        </div>
        {/* {!isDemo &&
          !isMentorSide &&
          mentorDto?.appControlDto?.agentHandoffButton &&
          lastOoniChatMsg?.chatMessageId === chatMessageDto.chatMessageId && (
            <div className="et-crtoc-handoff-to-agent-btn">
              <HandoffToAgentBtnComponent
                chatRoomDto={chatRoomDto}
                widgetId={widgetId}
              />
            </div>
          )} */}
        {chatRowOptionsElement && (
          <div className="et-acmcwc-ai-msg-chat-row-options">
            {chatRowOptionsElement}
          </div>
        )}
      </div>
      <p className="et-crtoc-msg-time" dir="auto">
        {chatMsgTime}
      </p>
    </div>
  ) : (
    <ShimmerWithEmptyImageComponent
      showShimmer={true}
      shimmerComponentType={
        VIDABOO_CONSTANTS.SHIMMER_COMPONENT_TYPES.CHAT_ROOM_TASK_OWNER
      }
    />
  );
};

export default ChatRoomTaskOwnerComponent;
